import React, { Component } from 'react'
import { Popover, Input, Icon } from 'antd';
import moment from 'moment';
if (process.env.__CLIENT__ === true) {
    require('./datepicker_full.less')
}

export default class DatePicker_Full extends Component {
    constructor(props) {
        super(props)
        this.state = {
            visible: false,
            showClear: false,
            err: '',
            msg: ''
        }
    }
    componentDidMount() {
        if (this.props.model) {
            this.props.model.addListener(this);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.value != this.state.value && !this.props.model) {
            this.setState({ value: nextProps.value });
        }
        if (!cb.utils.isEmpty(nextProps.open) && nextProps.open != this.state.visible && !this.props.model) {
            let open = cb.utils.isEmpty(nextProps.open) ? false : nextProps.open;
            this.setState({ visible: open });
        }
    }
    componentDidUpdate() {
        if (this.props.model)
            this.props.model.addListener(this);
    }
    componentWillUnmount() {
        if (this.props.model)
            this.props.model.removeListener(this);
    }
    onVisibleChange = (visible) => {
        if (this.state.disabled || this.state.readOnly || this.props.disabled) return;
        this.setState({ visible }, () => {
            if (this.props.onOpenChange) this.props.onOpenChange(visible);
        })
    }
    validate(val) {
        this.setState({
            err: 'has-' + val.type,
            msg: val.message
        });
    }
    onDateChange = (value, visible) => {
        if (this.props.model)
            this.props.model.setValue(value);
        if (this.props.onChange) this.props.onChange(cb.utils.isEmpty(value) ? null : moment(value));
        if (this.props.onOpenChange)
            this.props.onOpenChange(visible);
        else
            this.setState({ visible });
    }
    getShowValue = (value) => {
        if (cb.utils.isEmpty(value)) return '';
        return new Date(value).format('yyyy-MM-dd');
    }
    render() {
        let { value, visible, showClear, disabled, readOnly } = this.state;
        if (/Safari/.test(navigator.userAgent) && !cb.utils.isEmpty(value) && !moment.isMoment(value))
            value = value.replace(/\-/g, "/");
        const showValue = this.getShowValue(value);
        let className = this.state.err + " datepicker_full_err"
        return (
            <Popover visible={visible} onVisibleChange={this.onVisibleChange} trigger='click' arrowPointAtCenter overlayClassName='datepicker_full_pop' content={
                <Container value={value} onDateChange={this.onDateChange} />
            }>
                <span className={(disabled || readOnly || this.props.disabled) ? className + ' datepicker_full_disabled' : className} onMouseEnter={e => {
                    if (disabled || readOnly || this.props.disabled) return;
                    this.setState({ showClear: true });
                }} onMouseLeave={e => {
                    if (disabled || readOnly || this.props.disabled) return;
                    this.setState({ showClear: false });
                }}>
                    <Input value={showValue} readOnly />
                    {showClear && !cb.utils.isEmpty(value) ? <i className="datepicker_full_clear" onClick={e => {
                        this.setState({ showClear: false })
                        this.onDateChange('', false);
                    }}></i> : null}
                    <div className="ant-form-explain">{this.state.msg}</div>
                </span>
            </Popover>
        )
    }
}

class Container extends Component {
    constructor(props) {
        super(props)
        var selectYear = props.value ? new Date(props.value).getFullYear() : new Date().getFullYear();
        var selectMonth = props.value ? new Date(props.value).getMonth() + 1 : new Date().getMonth() + 1;
        var selectDay = props.value ? new Date(props.value).getDate() : new Date().getDate();
        this.state = {
            month: [
                { text: '一月', value: '1' }, { text: '二月', value: '2' }, { text: '三月', value: '3' }, { text: '四月', value: '4' },
                { text: '五月', value: '5' }, { text: '六月', value: '6' }, { text: '七月', value: '7' }, { text: '八月', value: '8' },
                { text: '九月', value: '9' }, { text: '十月', value: '10' }, { text: '十一月', value: '11' }, { text: '十二月', value: '12' }
            ],
            week: ['日', '一', '二', '三', '四', '五', '六'],
            selectYear,
            selectMonth,
            selectDay,
            nowDay: new Date().getDate(),
            nowMonth: new Date().getMonth() + 1,
            nowYear: new Date().getFullYear(),
            monthData: [],
            headType: 'day',
        }
    }
    componentDidMount() {
        this.getDataSource();
    }
    getDataSource = () => {
        const { selectYear, selectMonth } = this.state;
        var data = LunarCalendar.calendar(selectYear, selectMonth, true);
        this.setState({ monthData: data.monthData });
    }

    chose = (e, item) => {
        this.setState({ 'selectDay': item.day, 'selectYear': item.year, 'selectMonth': item.month }, () => {
            this.getDataSource();
        });
        const fullDate = /Safari/.test(navigator.userAgent) ? item.year + '/' + item.month + '/' + item.day : item.year + '-' + item.month + '-' + item.day;
        this.props.onDateChange(new Date(fullDate).format('yyyy-MM-dd'), false);
    }
    onMonthChange = (item) => {
        const { selectYear, selectDay } = this.state;
        this.setState({ 'selectMonth': item.value, headType: 'day' }, () => {
            this.getDataSource();
        });
        const fullDate = /Safari/.test(navigator.userAgent) ? selectYear + '-' + item.value + '-' + selectDay : selectYear + '-' + item.value + '-' + selectDay;
        this.props.onDateChange(new Date(fullDate).format('yyyy-MM-dd'), true);
    }
    onYearChange = (item) => {
        const { selectMonth, selectDay } = this.state;
        this.setState({ 'selectYear': item, headType: 'day' }, () => {
            this.getDataSource();
        });
        const fullDate = /Safari/.test(navigator.userAgent) ? item + '/' + selectMonth + '/' + selectDay : item + '-' + selectMonth + '-' + selectDay;
        this.props.onDateChange(new Date(fullDate).format('yyyy-MM-dd'), true);
    }
    onChangeDate = (type, direction, headType) => {
        let { selectYear, selectMonth, selectDay } = this.state;
        selectYear = Number(selectYear);
        selectMonth = Number(selectMonth);
        if (headType == 'year') {
            if (direction == 'left') {
                selectYear -= 12;
            } else {
                selectYear += 12;
            }
        } else {
            if (type == 'year') {
                if (direction == 'left') {
                    selectYear -= 1;
                } else {
                    selectYear += 1;
                }
            } else {
                if (direction == 'left') {
                    if (selectMonth === 1) {
                        selectMonth = 12;
                        selectYear -= 1;
                    } else {
                        selectMonth -= 1;
                    }
                } else {
                    if (selectMonth === 12) {
                        selectMonth = 1;
                        selectYear += 1;
                    } else {
                        selectMonth += 1;
                    }
                }
            }
        }
        this.setState({ selectYear, selectMonth }, () => {
            this.getDataSource();
        });
        const fullDate = /Safari/.test(navigator.userAgent) ? selectYear + '/' + selectMonth + '/' + selectDay : selectYear + '-' + selectMonth + '-' + selectDay;
        this.props.onDateChange(new Date(fullDate).format('yyyy-MM-dd'), true);
    }
    onMouseEnter = (e, item) => {
        this.setState({ 'hoverDay': item.day, 'hoverMonth': item.month })
    }
    onMouseLeave = (e, item) => {
        this.setState({ 'hoverDay': '', 'hoverMonth': '' })
    }
    changeheadType = (type) => {
        this.setState({ 'headType': type });
    }
    getStartYear = () => {
        const { selectYear } = this.state;
        let a = selectYear.toString().substr(0, selectYear.toString().length - 1);
        return Number(a + '0')
    }
    getHeader = () => {
        const { selectYear, selectMonth, headType } = this.state;
        let yearVal = '', pYear = 0, nYear = 0;
        if (headType == 'year') {
            let startYear = this.getStartYear();
            let endYear = startYear + 9;
            yearVal = startYear + '-' + endYear;
        }
        return (
            <div className='header1'>
                <a className='double_left' onClick={e => this.onChangeDate('year', 'left', headType)} />
                {headType == 'day' ? <a className='single_left' onClick={e => this.onChangeDate('month', 'left')} /> : null}
                {headType == 'day' ? <a className='header_year' onClick={e => this.changeheadType('year')}>{selectYear}年  </a> : null}
                {headType == 'day' ? <a className='header_month' onClick={e => this.changeheadType('month')}>{selectMonth}月</a> : null}
                {headType == 'year' ? <span className='year_header' >{yearVal}</span> : null}
                {headType == 'month' ? <a className='month_header' onClick={e => this.setState({ 'headType': 'year' })}>{selectYear}</a> : null}
                {headType == 'day' ? <a className='single_right' onClick={e => this.onChangeDate('month', 'right')} /> : null}
                <a className='double_right' onClick={e => this.onChangeDate('year', 'right', headType)} />
            </div>
        );
    }
    getBody = () => {
        const { selectYear, selectMonth, selectDay, monthData, week, month, nowDay, nowMonth, nowYear, hoverDay, hoverMonth, headType } = this.state;
        let yearBody = null;
        if (headType == 'year') {
            const startYear = this.getStartYear() - 1;
            const endYear = startYear + 12;
            yearBody = [];
            for (var i = startYear; i < endYear; i++) {
                const year = i;
                const className = year == selectYear ? 'month_year show' : 'month_year';
                yearBody.push(
                    <li className={className} onClick={e => this.onYearChange(year)} key={year}><span className='year-month'>{year}</span></li>
                )
            }
        }
        return (
            <div className={headType == 'day' ? 'monthes' : 'monthes years'}>
                {
                    headType == 'day' ?
                        week.map((item, index) => {
                            return (<li key={index}><span className='only-day'>{item}</span></li>)
                        }) : null
                }
                {
                    headType == 'month' ?
                        month.map((item, index) => {
                            const className = item.value == selectMonth ? 'month_year show' : 'month_year';
                            return (<li className={className} onClick={e => this.onMonthChange(item)} key={index}><span className='year-month'>{item.text}</span></li>)
                        }) : null
                }
                {yearBody}
                {
                    headType == 'day' ?
                        monthData.map((item, index) => {
                            const { day, lunarDayName, lunarMonthName, lunarFestival, month, year } = item;
                            if (lunarDayName == '初一') console.log(item)
                            var className = day == selectDay && month == selectMonth && year == selectYear ? 'show' : '';
                            if (month != selectMonth) className += ' noNowMonth';
                            if (nowDay == day && month == nowMonth && year == nowYear) className += ' nowDay';
                            if (day == hoverDay && month == hoverMonth) className += ' hover';
                            return (
                                <li onMouseEnter={e => this.onMouseEnter(e, item)} onMouseLeave={e => this.onMouseLeave(e, item)} className='day' key={index}
                                    className={className}
                                    onClick={e => this.chose(e, item)}
                                >
                                    <span className='day'>{nowDay == day && month == nowMonth && year == nowYear ? '今' : day}</span>
                                    <span className='lunar_day'>{lunarFestival || (lunarDayName == '初一' ? lunarMonthName : lunarDayName)}</span>
                                </li>
                            )
                        }) : null
                }
            </div>
        )
    }
    render() {
        const header = this.getHeader();
        const body = this.getBody();
        return (<div className='datepicker_full_container'>
            {header}
            {body}
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/datepicker_full/index.jsx